import {client} from '../helpers/api';

export async function getMyTimetable() {
  const response = await client.get('/api/my-timetable');

  if (response.data?.status) {
    return response.data?.data;
  } else if (response.data?.status === false) {
    throw response.data?.message || '';
  }
  throw response;
}
